import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";
import Receipt from "../Accountings/Receipt";

export default class Installment extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'installment',
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.refreshData();
	}
	save(e) {
		e.preventDefault();

		if (this.isBlank(this.state.data.record.interestRate)) this.state.data.record.interestRate = 0;
		if (this.isBlank(this.state.data.record.periodCount)) this.state.data.record.periodCount = 1;
		if (this.isBlank(this.state.data.record.periodValue)) this.state.data.record.periodValue = 1;
		if (this.isBlank(this.state.data.record.principalAmount)) this.state.data.record.principalAmount = 0;

		this.httpPost("api/v1/installment/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			date: this.convertMomentToDb(this.state.data.record.date),
			firstDueDate: this.convertMomentToDb(this.state.data.record.firstDueDate),
			contractNumber: this.state.data.record.contractNumber,
			interestRate: this.state.data.record.interestRate,
			interestType: this.state.data.record.interestType,
			periodValue: this.state.data.record.periodValue,
			personId: this.state.data.record.personId,
			periodUnit: this.state.data.record.periodUnit,
			periodCount: this.state.data.record.periodCount,
			principalAmount: this.state.data.record.principalAmount,
			factors: this.state.data.record.factors,
			guarantees: this.state.data.record.guarantees
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("قرارداد با موفقیت ذخیره شد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	start(e) {
		e.preventDefault();

		this.httpPost("api/v1/installment/start", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("قرارداد با موفقیت به جریان افتاد");

					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	onEditPerson(id) {
		this.showComponents({ component: <Person Caller={this} Id={id} FromAutoComplete={true} /> });
	}
	reciept(installmentScheduleId,type) {
		this.removeKeyDown();
		this.showComponents({ component: <Receipt Source={3} RefreshAfterSave={true} InstallmentScheduleId={installmentScheduleId} Type={type} Caller={this} /> });
	}
	refreshData() {
		this.httpPost("api/v1/installment/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setFactors(e) {
		this.state.data.record.factors = e;
		this.state.data.record.principalAmount = 0;
		e.forEach(f => {
			this.state.data.record.principalAmount += f.remain;
		});

		this.setState({ data: this.state.data });
	}
	getBlankGuarantee() {
		return {
			id: this.uuidv4(),
			price: 0,
			guaranteeType: 1,
			description: '',
		}
	}
	addNewGuarantee() {
		this.state.data.record.guarantees.push(this.getBlankGuarantee());
		this.setState({ data: this.state.data });
	}
	removeGuarantee(id) {
		var temp = [];
		this.state.data.record.guarantees.forEach(t => {
			if (t.id !== id) temp.push(t);
		});

		this.state.data.record.guarantees = temp;
		this.setState({ data: this.state.data });
	}
	setGuarantee(id, f, e) {
		this.state.data.record.guarantees.forEach(t => {
			if (t.id === id) {
				t[f] = e;
			}
		});

		this.setState({ data: this.state.data });
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">قرارداد فروش اقساطی</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>

							<ul className="nav nav-tabs mt-n3" role="tablist">
								<li className="nav-item" role="presentation">
									<a className="nav-link active" data-bs-toggle="tab" href="#tab1" aria-selected="false" role="tab" tabindex="-1"><span>قرارداد</span></a>
								</li>
								<li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab2" aria-selected="false" tabindex="-1" role="tab"><span>تضامین</span></a>
								</li>
								{this.state.data.record.status > 1 && <li className="nav-item" role="presentation">
									<a className="nav-link" data-bs-toggle="tab" href="#tab3" aria-selected="false" tabindex="-1" role="tab"><span>اقساط</span></a>
								</li>}
							</ul>

							<div className="tab-content">
								<div className="tab-pane active" id="tab1" role="tabpanel">
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group">
												<label for="invoiceContact" className="title1">فاکتورها</label>
												{this.state.data.record.status !== 1 ?
													this.state.data.record.factors.map(f => <a>{f.label}</a>)
													:
													<SelectAsync
														value={this.state.data.record.factors}
														isMulti={false}
														placeholder="انتخاب فاکتورها"
														defaultOptions
														loadOptions={(inputValue, callback) => this.loadFactorsOptions(inputValue, callback, 2)}
														onChange={e => this.setFactors(e)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label for="invoiceContact" className="title1">طرف حساب<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.personName}</b>
													: [
														<em className="icon ni ni-plus hand ms-1" onClick={e => this.setPerson({ value: -1 })}></em>,
														!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() && <em onClick={e => this.onEditPerson(this.state.data.record.personId)} className="icon ni ni-pen hand ms-1"></em>,
														<SelectAsync
															value={!this.isNull(this.state.data.record.personId) && this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
															isMulti={false}
															placeholder="انتخاب طرف حساب"
															defaultOptions
															loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 1)}
															onChange={e => this.setPerson(e)}
														/>
													]}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceDate" className="title1">تاریخ قرارداد<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.dateString}</b>
													:
													<DatePicker
														inputReadOnly={false}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.data.record.date = e }}
														value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceDueDate" className="title1">تاریخ اولین سررسید<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.firstDueDateString}</b>
													:
													<DatePicker
														inputReadOnly={false}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ اجرا"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.data.record.firstDueDate = e }}
														value={this.getFormatedDateForDatePicker(this.state.data.record.firstDueDate)}
													/>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">شماره قرارداد<span className="red">*</span></label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.contractNumber}</b>
													:
													<input onChange={e => this.state.data.record.contractNumber = parseInt(e.target.value)} defaultValue={this.state.data.record.contractNumber} autocomplete="off" type="text" className="form-control input-smnumber" maxLength="20" />
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">نوع بهره</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.interestTypeString}</b>
													:
													<select onChange={e => this.state.data.record.interestType = parseInt(e.target.value)} defaultValue={this.state.data.record.interestType} className="form-control input-smnumber">
														<option value="1">مبلغی</option>
														<option value="2">درصدی</option>
													</select>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">مقدار بهره</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.interestRate}</b>
													:
													<input onChange={e => this.state.data.record.interestRate = parseInt(e.target.value)} defaultValue={this.state.data.record.interestRate} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">تعداد اقساط</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.periodCount}</b>
													:
													<input onChange={e => this.state.data.record.periodCount = parseInt(e.target.value)} defaultValue={this.state.data.record.periodCount} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">دوره اقساط</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.periodUnitString}</b>
													:
													<select onChange={e => this.state.data.record.periodUnit = parseInt(e.target.value)} defaultValue={this.state.data.record.periodUnit} className="form-control input-smnumber">
														<option value="1">روزانه</option>
														<option value="2">ماهانه</option>
														<option value="2">سالانه</option>
													</select>
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">طول دوره</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.periodValue}</b>
													:
													<input onChange={e => this.state.data.record.periodValue = parseInt(e.target.value)} defaultValue={this.state.data.record.periodValue} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">اصل مبلغ</label>
												{this.state.data.record.status !== 1 ?
													<b>{this.state.data.record.principalAmount}</b>
													:
													<input onChange={e => this.state.data.record.principalAmount = parseInt(e.target.value)} defaultValue={this.state.data.record.principalAmount} type="text" className="form-control input-smnumber" />
												}
											</div>
										</div>
									</div>
								</div>
								<div className="tab-pane" id="tab2" role="tabpanel">
									{this.state.data.record.guarantees.map(target =>
										<div className="row g-4" key={target.id} style={{ "background-color": "#f4f4f4", "marginBottom": "15px" }}>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">نوع تضمین</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.guaranteeTypeString}</b>
														:
														<div className="form-control-wrap">
															<select className="form-control" type="text" defaultValue={target.guaranteeType} onChange={e => this.setGuarantee(target.id, 'guaranteeType', parseInt(e.target.value))}>
																<option value="1">چک</option>
																<option value="2">سفته</option>
																<option value="3">وثیقه نقدی</option>
																<option value="4">وثیقه ملکی/سند</option>
															</select>
														</div>
													}
												</div>
											</div>
											<div className="col-lg-2">
												<div className="form-group">
													<label className="form-label">مبلغ/ارزش</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.price}</b>
														:
														<div className="form-control-wrap">
															<input className="form-control ltr" type="text" defaultValue={target.price} onChange={e => this.setGuarantee(target.id, 'price', parseInt(e.target.value))} />
														</div>
													}
												</div>
											</div>
											<div className="col-lg-1" style={{ "display": "flex", "align-items": "center" }}>
												<div className="form-group">
													{this.state.data.record.status === 1 && <a className="btn btn-sm btn-danger" onClick={e => this.removeGuarantee(target.id)}>حذف</a>}
												</div>
											</div>
											<div className="col-lg-12">
												<div className="form-group">
													<label className="form-label">توضیحات</label>
													{this.state.data.record.status !== 1 ?
														<b>{target.description}</b>
														:
														<div className="form-control-wrap">
															<textarea className="form-control" defaultValue={target.description} onChange={e => this.setGuarantee(target.id, 'description', e.target.value)}></textarea>
														</div>
													}
												</div>
											</div>
										</div>
									)}
									{this.state.data.record.status === 1 && <div className="row g-4 mt-1">
										<div className="col-lg-12">
											<a className="btn btn-primary" onClick={e => this.addNewGuarantee()}>افزودن تضمین جدید</a>
										</div>
									</div>}
								</div>
								{this.state.data.record.status > 1 && <div className="tab-pane" id="tab3" role="tabpanel">
									<div className="nk-tb-list nk-tb-ulist">
										<div className="nk-tb-item nk-tb-head">
											<div className="nk-tb-col text-center"><span className="sub-text">شماره قسط</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">سررسید</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">اصل مبلغ</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">بهره</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">جریمه دیرکرد</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">جمع کل</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">پرداختی</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">مانده</span></div>
											<div className="nk-tb-col text-center"><span className="sub-text">وضعیت</span></div>
											<div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
										</div>
										{this.state.data.record.schedules.map((record, index) =>
											<div className="nk-tb-item">
												<div className="nk-tb-col">
													<span className="sub-text text-center">{record.contractNumber}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{record.dueDateString}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.principalAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.interestAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.penaltyAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.totalAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.paidAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{this.money(record.remainAmount)}</span>
												</div>
												<div className="nk-tb-col">
													<span className="sub-text text-center">{record.statusString}</span>
												</div>
												<div className="nk-tb-col text-end">
													{record.status !== 3 && <a onClick={e => this.reciept(record.id,1)} className="hand text-primary mx-1" title="ویرایش">دریافت</a>}
												</div>
											</div>
										)}
									</div>
								</div>}
							</div>

						</div>
						<div className="modal-footer">
							{this.state.data.record.status === 1 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>}
							{this.state.data.record.id != this.getDefaultGuid() && this.state.data.record.status === 1 && <button type="button" className="hand btn btn-success" onClick={e => this.start(e)} >فعال شدن</button>}
							{this.state.data.record.status !== 1 && <button type="button" className="hand btn btn-danger" onClick={e => this.getPdf(this.state.data.record.id)} >PDF</button>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}